import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// material
import { IconButton, Menu, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Iconify from '../../components/iconify';
import { PATH_MAIN } from '../../routes/paths';
import NewUserModalPopup from './newusermodalpopup';
import { ACCESSABLE_VALUE } from '../../auth/utils';
// ----------------------------------------------------------------------------------------------------------------

UserMasterMoreMenu.propTypes = {
    cellValues: PropTypes.object,
};
// ----------------------------------------------------------------------------------------------------------------

export default function UserMasterMoreMenu({ cellValues }) {

    const navigate = useNavigate();
    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [activeFlag, setActiveFlag] = useState(false);
    const [openForm, setOpenForm] = useState(false);
    const [openInactiveForm, setOpenInactiveForm] = useState(false);
    const [userEditData, setUserEditData] = useState(false);
    const [userInActiveData, setUserInactiveData] = useState(false);
    const [headerName, setheaderName] = useState('');
    const [ActiveInactiveUpdate, setActiveInactiveUpdate] = useState('');

    const loggedInUserDetails = useSelector(state => state.userdetails.userValue);
    const mastersPageAccess = loggedInUserDetails?.MastersPageAccess?.[0];

    const editUserView = mastersPageAccess ? mastersPageAccess[`EditUserView`.toLowerCase()] : '1';
    const activateUserView = mastersPageAccess ? mastersPageAccess[`ActivateUserView`.toLowerCase()] : '1';
    const userMasterMoreMenuView = mastersPageAccess ? mastersPageAccess[`UserMasterMoreMenuView`.toLowerCase()] : '1';

    // const handleEditDetails = () => {
    //    setUserEditData(cellValues.row, true, userStatus ? 'Active' : 'In-Active');
    // }

    // const handleInactiveDetails = () => {
    //    setUserInactiveData(cellValues.row, true, userStatus ? 'Active' : 'In-Active');
    // }

    const handelClick = () => {
        setIsOpen(true)
    };
    const handelInActive = () => {
        //    const userStatus = cellValues.row.userStatus;
        //    navigate(PATH_MAIN.master.userdata, { state: { row: cellValues.row, flag: true, header: 'User', subheader:  userStatus ? 'Active' : 'In-Active'} });

        setOpenForm(true);
        setheaderName(activeFlag ? 'Activate User' : 'In-Activate User');
        setActiveInactiveUpdate(activeFlag ? 'Activate User' : 'In-Activate User');

    };

    const handelEditUser = () => {
        //    navigate(PATH_MAIN.master.userdata, { state: { row: cellValues.row, flag: false, header: 'User', subheader:'Edit'} });
        setOpenForm(true);
        setActiveFlag(false);
        setheaderName('Edit User');
        setActiveInactiveUpdate('Update');
    };



    useEffect(() => {
        if (cellValues.row.userStatus === 'Active') {
            setActiveFlag(false);
        }
        else {
            setActiveFlag(true);
        }
    }, [cellValues.row]);

    const handleConfirm = () => {
        setOpenForm(false);
    };
    return (
        <>
            {userMasterMoreMenuView === ACCESSABLE_VALUE &&
                <IconButton ref={ref} onClick={handelClick}>
                    <Iconify icon="ic:baseline-more-vert" width='20px' height='20px' />
                </IconButton>
            }

            <Menu
                open={isOpen}
                anchorEl={ref.current}
                onClose={() => setIsOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <Stack direction='column' alignItems='center' justifyContent='left' pl={1} pr={3}>
                    {editUserView === ACCESSABLE_VALUE &&
                        <Button size='small' sx={{ color: 'text.primary', '&:hover': { color: 'text.main' } }} onClick={handelEditUser} >
                            Edit
                        </Button>
                    }

                    {activateUserView === ACCESSABLE_VALUE &&
                        <Button size='small' sx={{ color: 'text.primary', '&:hover': { color: 'text.main' } }}
                            onClick={handelInActive}>
                            {activeFlag ? 'Activate User' : 'In-Activate User'}
                        </Button>
                    }

                </Stack>
            </Menu>

            {openForm &&
                <NewUserModalPopup row={cellValues.row} flag={headerName !== 'Edit User'} disableFlag='' confirm={handleConfirm} headerName={headerName} ActiveInActiveUpdate={ActiveInactiveUpdate} />
            }
        </>
    );
}